import { useEffect, useState } from 'react';
import {
  SAVED_SEARCHES_STORAGE_KEY,
  listSavedSearches,
  type SavedSearch
} from '$lib/lib/savedSearches';

// Reactive view onto savedSearches storage. Listens to:
//  - 'storage' events (cross-tab updates from other windows)
//  - 'rentallens:savedSearches' custom events (same-tab updates from
//    create/update/delete in this app — same-tab storage doesn't fire 'storage')
export function useSavedSearches(): SavedSearch[] {
  const [items, setItems] = useState<SavedSearch[]>(() => listSavedSearches());

  useEffect(() => {
    function refresh() {
      setItems(listSavedSearches());
    }
    function onStorage(e: StorageEvent) {
      if (e.key === SAVED_SEARCHES_STORAGE_KEY || e.key === null) refresh();
    }
    window.addEventListener('storage', onStorage);
    window.addEventListener('rentallens:savedSearches', refresh);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('rentallens:savedSearches', refresh);
    };
  }, []);

  return items;
}
